<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input v-model="searchParams.policyNo" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">批单号</span>
        <Input v-model="searchParams.billNo" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">险种分类</span>
        <Select v-model="searchParams.themeIds" clearable transfer filterable multiple>
          <Option :value="item.themeId" v-for="(item, index) in productThemeList" :key="index">{{ item.title }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">费用类型</span>
        <Select v-model="searchParams.commissionStyles" clearable transfer multiple>
          <Option value="1">基础费用</Option>
          <Option value="2">团队长基础管理费</Option>
          <Option value="3">限时加费</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">承保日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择时间"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">出单人</span>
         <Input v-model="searchParams.salesmanCondition" clearable placeholder="请输入姓名或工号" />
      </div>
      <div class="input-item">
        <span class="label label-null">.</span>
      </div>

      <div class="btn-item">
        <Button type="primary" class="btn-reset" ghost @click="exportTable">导出</Button>
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData"></Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="changePage" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import { treeFlatArr } from '@/api/filter';

export default {
  mixins: [pageTool, common],
  data() {
    return {
      searchParams: {
        date: []
      },
      productThemeList: [],
      columns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 220
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '险种分类',
          align: 'center',
          key: 'themeName',
          minWidth: 120
        },
        {
          title: '最新状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '实收保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用类型',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            const owerType = params.row.owerType;
            const commissionType = params.row.commissionType;
            if (owerType == 2 && (commissionType == 1 || commissionType == 3)) {
              return <span>团队长基础管理费</span>;
            } else if (owerType == 3 && (commissionType == 1 || commissionType == 3)) {
              return <span>基础费用</span>;
            } else if (commissionType == 2 || commissionType == 4 || commissionType == 20) {
              return <span>限时加费</span>;
            } 
          }
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 100,
          render(h, params) {
            let commission = params.row.commission;
            return <span>{ commission? commission+'%' : '-' }</span>
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 100
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName',
          minWidth: 100
        },
        {
          title: '业务类别',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sellType = JSON.parse(params.row.sellType);
            if (sellType.includes('1')) {
              return <span>网销产品</span>;
            } else if (sellType.includes('3')) {
              return <span>经代产品</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 100
        }
      ]
    };
  },
  created() {
    this.getProductTheme();
    this.getList();
  },

  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    getList() {
      let data = JSON.parse(JSON.stringify(this.searchParams));
      // 承保日期
      if (data.date && data.date[0]) {
        data.insureTimeStart = data.date[0];
        data.insureTimeEnd = data.date[1];
      }
      delete data.date;
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryUserWaitWithSelf',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 2,
          ...data,
          owerTypes: [2, 3],
          feeStatus: 1, //默认参数
          settlementStatus: 0 //默认参数
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 导出
    exportTable() {
      if(!this.tableData.length) {
        this.$notice.msg("暂无可导出数据");
        return
      }
      let data = JSON.parse(JSON.stringify(this.searchParams));
      // 承保日期
      if (data.date && data.date[0]) {
        data.insureTimeStart = data.date[0];
        data.insureTimeEnd = data.date[1];
      }
      delete data.date;
      let searchParams = {
        type: 2,
        ...data,
        owerTypes: [2, 3],
        feeStatus: 1, //默认参数
        settlementStatus: 0 //默认参数
      };
      this.$units.downloadFile('/buz/commissionLog/exportUserWaitWithSelf', searchParams, 'POST');
    },

    //险种分类
    getProductTheme() {
      let id = Object.keys(JSON.parse(localStorage.dic).GROUP_THEME_ID)[0];
      this.$http({
        url: '/buz/productThemeJoin/queryProductTheme',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.productThemeList = treeFlatArr(this.dealTree1(res.data)).filter(item => item.level == 2);
      });
    },
    dealTree1(arr) {
      return arr.map(item => {
        return {
          ...item,
          value: item.themeId,
          label: item.name,
          title: item.name,
          expand: true,
          children: item.child && item.child.length > 0 ? this.dealTree1(item.child, item.name) : null
        };
      });
    },

    resetSearch() {
      this.searchParams = {};
      this.searchParams.date = [];
      this.searchAjax();
    },

    // 分页
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.label-null {
  color: #fff !important;
}
</style>
